import React, { FC } from 'react';

import styles from './BackTop.module.scss';

interface Props {
  visible: boolean;
  back: () => void;
}

const BackToTop: FC<Props> = (props) => {
  const { visible, back } = props;
  return (
    <div
      className={styles['back-to-top']}
      onClick={() => {
        back();
      }}
      style={visible ? { visibility: 'visible' } : { visibility: 'hidden' }}
    >
      <svg className="h-full w-full" viewBox="0 0 48 48">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-630.000000, -1350.000000)" fill="#000000" fillRule="nonzero">
            <g id="top" transform="translate(630.000000, 1350.000000)">
              <rect opacity="0" x="0" y="0" width="48" height="48" />
              <path d="M22.5,17.345 L13.1218114,26.7753096 C12.5375482,27.36282 11.5876813,27.3655912 11,26.7815 C10.412524,26.1976129 10.4096146,25.2480356 10.9935017,24.6605596 C10.9935947,24.660466 10.9936876,24.6603725 10.9937806,24.660279 L23.291,12.294 L23.291,12.294 C23.6806711,11.9027883 24.3136724,11.9014453 24.705,12.291 L24.709,12.295 L37.0061798,24.6603184 C37.5902219,25.2475967 37.5875985,26.1971396 37.0003201,26.7811817 C37.0002134,26.7812878 37.0001067,26.7813939 37,26.7815 C36.4123187,27.3655912 35.4624518,27.36282 34.8781886,26.7753096 L25.5,17.345 L25.5,17.345 L25.5,42.282 C25.5,43.1104271 24.8284271,43.782 24,43.782 C23.1715729,43.782 22.5,43.1104271 22.5,42.282 L22.5,17.345 L22.5,17.345 Z M7.5,3.99999998 L40.5,3.99999998 C41.3284271,3.99999998 42,4.67157286 42,5.49999998 C42,6.32842711 41.3284271,6.99999998 40.5,6.99999998 L7.5,6.99999998 C6.67157288,6.99999998 6,6.32842711 6,5.49999998 C6,4.67157286 6.67157288,3.99999998 7.5,3.99999998 Z" />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default BackToTop;
